import { render } from "./LessonProductOptions.vue?vue&type=template&id=3e4cd63b&scoped=true"
import script from "./LessonProductOptions.vue?vue&type=script&lang=js"
export * from "./LessonProductOptions.vue?vue&type=script&lang=js"

import "./LessonProductOptions.vue?vue&type=style&index=0&id=3e4cd63b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4cd63b"]])

export default __exports__